import Component from 'inferno-component';
import './registerServiceWorker';

import Navigation from './components/navigation/Navigation';
import Footer from './components/footer/Footer';

import './App.css';

class App extends Component {
  render() {
    return (
      <div className="app">
        <Navigation>
          {this.props.children}
          <Footer />
        </Navigation>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js